import React from 'react';
import styles from './card.module.scss';

/**
 * @color - color of card (violet or white);
 * @text - text on card;
 * @img - src to card image;
 * @className - html class for card
 */
const Card = ({ color = 'violet', text, img, className, classNameImg, }) => {
  return (
    <div
      className={`
        ${styles.wrapper} ${color === 'violet' ? styles.violet : styles.white}
        ${className ? className : ''}
      `}
    >
      <div
        className={styles.blur}
      >
        <div className={`${styles.img} ${classNameImg}`}>
          <img src={img} alt="card img"/>
        </div>
      </div>
      <div className={styles.desc}>
        <h4 className={styles.text}>{text}</h4>
      </div>
    </div>
  );
};

export default Card;